import React from "react";
import { CustomReportsContainer } from "../../../containers";
const CustomReports = (props) => {
  return <CustomReportsContainer {...props} />;
};

export default CustomReports;
